<template>
  <div style="position: relative">
    <FilterFields
      v-if="!isAmbienteRoute"
      :fields="[
        {
          type: 'text',
          label: 'Número',
          field: 'numero',
        },
        {
          type: 'text',
          label: 'Nome',
          field: 'nome',
        },
        {
          type: 'text',
          label: 'Ambiente',
          field: 'ambiente_nome',
        },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: ['Todos', 'Livre', 'Ocupada', 'Reservada', 'Inativa'],
        },
        {
          type: 'select',
          label: 'Ativo',
          field: 'ativo',
          options: ['Todos', 'Ativo', 'Inativo'],
        },
      ]"
    />
    <TableApp
      :titulo="tituloTabela"
      :acaoBtn="novaMesaUrl"
      textoBtn="Novo"
      :secondaryButtonUrl="secondaryButtonUrl"
      :secondaryButtonText="secondaryButtonText"
      api-url="/restaurante/mesas"
      :fields="fields"
      :extraParams="tableExtraParams"
      ref="mesas"
      :perPage="10"
    >
      <template slot="customRow" scope="props">
        <span v-if="props.field == 'status'">
          <span :class="statusClass(props.rowData.status)">
            {{ statusLabel(props.rowData.status) }}
          </span>
        </span>
        <span v-if="props.field == 'ativo'">
          <span
            v-if="props.rowData.ativo == true"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>
        <span v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 170px">
              <div class="dropdown dropdown-inline">
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Editar'"
                  :to="mesaEditRoute(props.rowData)"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Excluir'"
                >
                  <TrashCanIcon :size="16" />
                </button>
                <button
                  @click="abrirQrCode(props.rowData)"
                  class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'QR Code'"
                >
                  <QrcodeIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
    <b-modal
      v-model="qrCodeModalVisible"
      title="QR Code do Self Pedido"
      size="md"
      centered
      hide-footer
    >
      <div v-if="qrCodeLoading" class="text-center py-5">
        <span class="spinner spinner-primary spinner-lg"></span>
      </div>
      <div v-else-if="qrCodeData">
        <div ref="selfPedidoQrPrint" class="self-pedido-qr-print text-center">
          <h4 class="mb-2">Self Pedido</h4>
          <p class="mb-1"><strong>Mesa:</strong> {{ qrCodeMesaTitulo }}</p>
          <p class="mb-4" v-if="qrCodeAmbiente">
            <strong>Ambiente:</strong> {{ qrCodeAmbiente }}
          </p>
          <div class="self-pedido-qr-box">
            <QrCodeVue :value="qrCodeUrl" :size="240" level="M" />
          </div>
          <p class="self-pedido-qr-url mt-4 mb-0">{{ qrCodeUrl }}</p>
        </div>

        <div
          v-if="!qrCodeData.self_pedido.ativo"
          class="alert alert-warning mt-4 mb-0"
        >
          Self Pedido está inativo nas configurações gerais do restaurante.
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button
            class="btn btn-light-primary btn-sm mr-2"
            type="button"
            @click="copiarQrCodeUrl"
          >
            <ContentCopyIcon :size="16" class="mr-1" />
            Copiar URL
          </button>
          <a
            class="btn btn-light-info btn-sm mr-2"
            :href="qrCodeUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <OpenInNewIcon :size="16" class="mr-1" />
            Abrir
          </a>
          <button
            class="btn btn-primary btn-sm"
            type="button"
            @click="imprimirQrCode"
          >
            <PrinterIcon :size="16" class="mr-1" />
            Imprimir
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import QrcodeIcon from "vue-material-design-icons/Qrcode.vue";
import PrinterIcon from "vue-material-design-icons/Printer.vue";
import ContentCopyIcon from "vue-material-design-icons/ContentCopy.vue";
import OpenInNewIcon from "vue-material-design-icons/OpenInNew.vue";
import QrCodeVue from "qrcode.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-restaurante-mesas",
  components: {
    Pencil,
    TrashCanIcon,
    QrcodeIcon,
    PrinterIcon,
    ContentCopyIcon,
    OpenInNewIcon,
    QrCodeVue,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          sortable: true,
          width: "12%",
        },
        {
          label: "Nome",
          field: "nome",
          type: "text",
          sortable: true,
          width: "20%",
        },
        {
          label: "Ambiente",
          field: "ambiente_nome",
          type: "text",
          sortable: true,
          width: "20%",
        },
        {
          label: "Capacidade",
          field: "capacidade",
          type: "number",
          sortable: true,
          width: "12%",
        },
        {
          label: "Status",
          field: "status",
          type: "text",
          sortable: true,
          slot: true,
          width: "14%",
        },
        {
          label: "Ativo",
          field: "ativo",
          type: "text",
          sortable: true,
          slot: true,
          width: "10%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "12%",
        },
      ],
      qrCodeModalVisible: false,
      qrCodeLoading: false,
      qrCodeData: null,
    };
  },
  methods: {
    statusLabel(status) {
      const labels = {
        livre: "Livre",
        ocupada: "Ocupada",
        reservada: "Reservada",
        inativa: "Inativa",
      };

      return labels[status] || status;
    },
    statusClass(status) {
      const classes = {
        livre: "label label-lg label-inline label-light-success",
        ocupada: "label label-lg label-inline label-light-danger",
        reservada: "label label-lg label-inline label-light-warning",
        inativa: "label label-lg label-inline label-light-dark",
      };

      return classes[status] || "label label-lg label-inline label-light";
    },
    nomeMesa(data) {
      return data.nome ? data.numero + " - " + data.nome : data.numero;
    },
    mesaEditRoute(mesa) {
      if (!this.isAmbienteRoute) {
        return {
          name: "restauranteMesasEditar",
          params: {
            id: mesa.id,
          },
        };
      }

      return {
        name: "restauranteAmbientesMesasEditar",
        params: {
          ambienteId: this.ambienteId,
          id: mesa.id,
        },
        query: {
          ambiente_nome: this.ambienteNome,
        },
      };
    },
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a mesa " + this.nomeMesa(data) + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/restaurante/mesas/delete", {
              id: data.id,
            });

            this.$refs.mesas.refresh();
            this.$toast.success("Mesa excluída!");
          }
        });
    },
    async abrirQrCode(mesa) {
      this.qrCodeData = null;
      this.qrCodeLoading = true;
      this.qrCodeModalVisible = true;

      try {
        const response = await this.$http.get(
          `/restaurante/mesas/${mesa.id}/self-pedido-qr`
        );
        this.qrCodeData = response.data;
      } catch (error) {
        this.qrCodeModalVisible = false;
        this.$toast.error(
          error.response?.data?.msg || "Não foi possível carregar o QR Code."
        );
      } finally {
        this.qrCodeLoading = false;
      }
    },
    async copiarQrCodeUrl() {
      if (!this.qrCodeUrl) {
        return;
      }

      if (this.$copyText) {
        await this.$copyText(this.qrCodeUrl);
      } else {
        await navigator.clipboard.writeText(this.qrCodeUrl);
      }

      this.$toast.success("URL copiada!");
    },
    imprimirQrCode() {
      const printArea = this.$refs.selfPedidoQrPrint;
      const canvas = printArea ? printArea.querySelector("canvas") : null;
      const qrCodeImage = canvas ? canvas.toDataURL("image/png") : "";
      const janela = window.open("", "_blank", "width=480,height=680");

      if (!janela) {
        this.$toast.error("Não foi possível abrir a janela de impressão.");
        return;
      }

      janela.document.write(`
        <!doctype html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>QR Code do Self Pedido</title>
            <style>
              body {
                margin: 0;
                padding: 24px;
                font-family: Arial, sans-serif;
                color: #1f2937;
                text-align: center;
              }
              h1 {
                margin: 0 0 10px;
                font-size: 24px;
              }
              p {
                margin: 6px 0;
                font-size: 15px;
              }
              img {
                width: 260px;
                height: 260px;
                margin: 22px auto 18px;
                display: block;
              }
              .url {
                margin-top: 16px;
                font-size: 12px;
                word-break: break-all;
              }
            </style>
          </head>
          <body>
            <h1>Self Pedido</h1>
            <p><strong>Mesa:</strong> ${this.escapeHtml(
              this.qrCodeMesaTitulo
            )}</p>
            <p><strong>Ambiente:</strong> ${this.escapeHtml(
              this.qrCodeAmbiente || "Não informado"
            )}</p>
            ${
              qrCodeImage
                ? `<img src="${qrCodeImage}" alt="QR Code do Self Pedido">`
                : ""
            }
            <p class="url">${this.escapeHtml(this.qrCodeUrl)}</p>
          </body>
        </html>
      `);
      janela.document.close();
      janela.focus();
      janela.print();
    },
    escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    isAmbienteRoute() {
      return !!(this.$route.query.ambiente_id || this.$route.params.ambienteId);
    },
    ambienteId() {
      return (
        this.$route.query.ambiente_id || this.$route.params.ambienteId || null
      );
    },
    ambienteNome() {
      return this.$route.query.ambiente_nome || "Ambiente";
    },
    tituloTabela() {
      return this.isAmbienteRoute
        ? `Mesas - ${this.ambienteNome}`
        : "Cadastro de Mesas";
    },
    novaMesaUrl() {
      if (!this.isAmbienteRoute) {
        return "/#/restauranteMesas/novo";
      }

      return `/#/restauranteAmbientes/${
        this.ambienteId
      }/mesas/novo?ambiente_nome=${encodeURIComponent(this.ambienteNome)}`;
    },
    secondaryButtonUrl() {
      return this.isAmbienteRoute
        ? "/#/restauranteAmbientes"
        : "/#/restauranteMesas";
    },
    secondaryButtonText() {
      return this.isAmbienteRoute ? "Ambientes" : "Salão";
    },
    tableExtraParams() {
      return this.isAmbienteRoute
        ? {
            ambiente_id: this.ambienteId,
          }
        : {};
    },
    selfPedidoPublicBaseUrl() {
      const configuredBaseUrl = process.env.VUE_APP_SELF_PEDIDO_BASE_URL;

      if (configuredBaseUrl) {
        return configuredBaseUrl.replace(/\/+$/, "");
      }

      const host = window.location.hostname;

      if (host && host !== "localhost" && host !== "127.0.0.1") {
        return `${window.location.protocol}//${host}:5173`.replace(/\/+$/, "");
      }

      return "http://192.168.1.116:5173";
    },
    qrCodeUrl() {
      if (!this.qrCodeData) {
        return "";
      }

      return `${this.selfPedidoPublicBaseUrl}${this.qrCodeData.self_pedido.path}`;
    },
    qrCodeMesaTitulo() {
      if (!this.qrCodeData) {
        return "";
      }

      const mesa = this.qrCodeData.mesa;

      return mesa.nome ? `${mesa.numero} - ${mesa.nome}` : mesa.numero;
    },
    qrCodeAmbiente() {
      return this.qrCodeData?.mesa?.ambiente?.nome || "";
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>

<style scoped>
.self-pedido-qr-print {
  color: #1f2937;
}

.self-pedido-qr-box {
  display: inline-flex;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
}

.self-pedido-qr-url {
  word-break: break-all;
  font-size: 12px;
  color: #6b7280;
}
</style>
